// extracted by mini-css-extract-plugin
export var bodyRow = "_fy-d";
export var cardColumns = "_fy-e";
export var ellipsesOverflow = "_fy-2";
export var flatBottomCorners = "_fy-3";
export var flatTopCorners = "_fy-4";
export var headerActionsDropdown = "_fy-f";
export var headerBottomRow = "_fy-c";
export var headerTopRow = "_fy-b";
export var orderDetailsWrapper = "_fy-0";
export var orderInfoContainer = "_fy-1";
export var productDetails = "_fy-9";
export var productImage = "_fy-5";
export var responsiveTable = "_fy-8";
export var shipmentContainer = "_fy-a";
export var tableBottomLeft = "_fy-6";
export var tableBottomRight = "_fy-7";
export var trackingLink = "_fy-g";